module.exports = __webpack_public_path__ + "static/media/ils_loan_email.2bfb2ea9.svg";